import { normalizeSheetRows } from "./payloadRows";
import { readLinkedValues, serializeUniqueCodes } from "./multiValueExport";
import { isSampleTestRow } from "./sampleDataFilter";

export { readLinkedValues, serializeUniqueCodes } from "./multiValueExport";

const normalizeCode = (value: unknown): string => {
  const values = readLinkedValues(value);
  return values[0] ?? "";
};

/** One RateTypeMapping row per player type with all linked rate types. */
export const mapRateTypeMappingRows = (
  sheetData: unknown,
): Record<string, unknown>[] => {
  const grouped = new Map<string, string[]>();

  for (const row of normalizeSheetRows(sheetData)) {
    if (isSampleTestRow(row)) {
      continue;
    }

    const playerType = normalizeCode(row["Player Type"]);
    const rateTypes = readLinkedValues(row["Rate Type"]);
    if (!playerType || rateTypes.length === 0) {
      continue;
    }

    const existing = grouped.get(playerType) ?? [];
    existing.push(...rateTypes);
    grouped.set(playerType, existing);
  }

  return Array.from(grouped.entries()).map(([playerType, rateTypes]) => ({
    "Player Type": playerType,
    "Rate Type": serializeUniqueCodes(rateTypes),
  }));
};

/** One PlayerTypeMapping row per allocation block with all linked player types. */
export const mapPlayerTypeMappingRows = (
  sheetData: unknown,
): Record<string, unknown>[] => {
  const grouped = new Map<string, string[]>();

  for (const row of normalizeSheetRows(sheetData)) {
    if (isSampleTestRow(row)) {
      continue;
    }

    const allocationBlock = normalizeCode(row["Allocation Block Code"]);
    const playerTypes = readLinkedValues(row["Player Type"]);
    if (!allocationBlock || playerTypes.length === 0) {
      continue;
    }

    const existing = grouped.get(allocationBlock) ?? [];
    existing.push(...playerTypes);
    grouped.set(allocationBlock, existing);
  }

  return Array.from(grouped.entries()).map(
    ([allocationBlock, playerTypes]) => ({
      "Allocation Block Code": allocationBlock,
      "Player Type": serializeUniqueCodes(playerTypes),
    }),
  );
};
